import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { Button, ButtonLink } from "@/components/Buttons";
import { TextField } from "@/components/Form/Parts/index";
import routes from "@/lib/routes";
import formStyles from "@/styles/Form.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as y from "yup";
import { useUppercaseCaution } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var schema = y.object().shape({
  mailAddress: y.string().email("メールアドレスの形式で入力してください。").required("メールアドレスが入力されていません。")
});
export default function Step1(_ref) {
  var _errors$mailAddress;

  var onSubmit = _ref.onSubmit,
      error = _ref.error;

  var _useForm = useForm({
    resolver: yupResolver(schema),
    mode: "all"
  }),
      formState = _useForm.formState,
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.errors;

  var isDirty = formState.isDirty,
      isValid = formState.isValid,
      isSubmitting = formState.isSubmitting;

  var _useUppercaseCaution = useUppercaseCaution(),
      _useUppercaseCaution2 = _slicedToArray(_useUppercaseCaution, 2),
      handleChange = _useUppercaseCaution2[0],
      uppercaseCautionMessage = _useUppercaseCaution2[1];

  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSubmit(onSubmit),
    noValidate: true,
    children: [/*#__PURE__*/_jsx("div", {
      className: processStyles.contentWrapper,
      children: /*#__PURE__*/_jsxs("div", {
        className: processStyles.content,
        children: [/*#__PURE__*/_jsxs("p", {
          children: ["SPOOX ID\u3068\u3057\u3066\u3054\u5229\u7528\u3044\u305F\u3060\u304FE\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), "\u5165\u529B\u3057\u305FE\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u5C4A\u3044\u305F4\u6841\u306E\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u6B21\u30DA\u30FC\u30B8\u3067\u5165\u529B\u3057\u3066\u767B\u9332\u3092\u9032\u3081\u3066\u304F\u3060\u3055\u3044\u3002"]
        }), /*#__PURE__*/_jsx("fieldset", {
          className: formStyles.basicFieldset,
          children: /*#__PURE__*/_jsx(TextField, {
            ref: register,
            title: "E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF08\u30ED\u30B0\u30A4\u30F3ID\uFF09",
            type: "email",
            name: "mailAddress",
            placeholder: "\u534A\u89D2\u82F1\u6570\u5B57\u3067\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B",
            caption: "ドメイン指定受信に「skyperfectv.co.jp」を設定してください。",
            error: ((_errors$mailAddress = errors.mailAddress) === null || _errors$mailAddress === void 0 ? void 0 : _errors$mailAddress.message) || (error === null || error === void 0 ? void 0 : error.message) || uppercaseCautionMessage,
            onChange: handleChange,
            autoComplete: "email",
            required: true
          })
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: formStyles.btnArea,
      children: /*#__PURE__*/_jsx(Button, {
        type: "submit",
        fillMainColor: true,
        fontFixed: true,
        large: true,
        disabled: !isDirty || !isValid,
        loading: isSubmitting,
        children: "\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u9001\u4FE1\u3059\u308B"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "".concat(processStyles.noticeArea, " ").concat(processStyles.mt40),
      children: [/*#__PURE__*/_jsx("h4", {
        className: processStyles.noticeHeading,
        children: "My\u30B9\u30AB\u30D1\u30FC\uFF01ID\u3092\u304A\u6301\u3061\u306E\u65B9\u3078"
      }), /*#__PURE__*/_jsxs("p", {
        className: "".concat(processStyles.noticeCaption, " ").concat(processStyles.gray),
        children: ["My\u30B9\u30AB\u30D1\u30FC\uFF01ID\u3067\u306E\u767B\u9332\u3067\u306E\u30E1\u30EA\u30C3\u30C8", /*#__PURE__*/_jsx("br", {}), "\u30FBMy\u30B9\u30AB\u30D1\u30FC\uFF01ID\u3067\u3054\u767B\u9332\u306E\u60C5\u5831\u3067\u4F1A\u54E1\u767B\u9332\u304C\u7C21\u5358\u306B\u306A\u308A\u307E\u3059\u3002", /*#__PURE__*/_jsx("br", {}), "\u30FB\u653E\u9001\u5951\u7D04\u8005\u9650\u5B9A\u306E\u304A\u5F97\u306A\u5272\u5F15\u3084\u7279\u5178\u3092\u53D7\u3051\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"]
      }), /*#__PURE__*/_jsx(ButtonLink, {
        href: routes.myskpSignupLogin,
        fillColor: true,
        fontFixed: true,
        large: true,
        children: "My\u30B9\u30AB\u30D1\u30FC\uFF01ID\u3067\u4F1A\u54E1\u767B\u9332"
      })]
    })]
  });
}